import { ReactNode } from "react";
import { cn } from "../../lib/utils";

type Props = {
  children: ReactNode;
  className?: string;
};

export const TypographyXS = ({ children, className, ...props }: Props) => {
  return (
    <p className={cn("text-xs", className)} {...props}>
      {children}
    </p>
  );
};
